// extracted by mini-css-extract-plugin
export var blogPostList = "index-module--blog-post-list--44443";
export var cta = "index-module--cta--5a558";
export var image = "index-module--image--6dca2";
export var text = "index-module--text--24699";